var cookies = require("./cookie");
var request = require("../request");
var config = require('../config').config;
var modal = require("../modal");

function init() {
  setDefault()
  var element = document.querySelector('[data-cookie-preferences]');

  if (element && !cookies.get('COOKIE_PREFERENCES')) {
    element.hidden=false;
    addSpaceBlock(element);

    var editPrefBtn = element.querySelector('[data-cookie-preferences-edit]');
    if (editPrefBtn) {
      editPrefBtn.addEventListener('click',function(){
        element.hidden=true;
      })
    }
  }

  var editElement = document.querySelector('[data-cookie-preferences-form]');
  if (editElement) {
    element.hidden=true;
    editElement.hidden=false;
  }
}

function setDefault() {
  if (config.enableGdprCookiePreferences) {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }

    //use stored settings
    if (config.stCookiePreferences) {
      var prefs = JSON.parse(config.stCookiePreferences)
      gtag('consent', 'default', {
        ad_storage: prefs.marketing==1?'granted':'denied',
        analytics_storage: prefs.analytics==1?'granted':'denied',
        functional_storage: prefs.functional == 1 ? 'granted' : 'denied',
        ad_user_data: prefs.marketing==1?'granted':'denied',
        ad_personalization:	prefs.marketing==1?'granted':'denied'
      });
    } else {
      //set cookies preferences using gtag
      gtag('consent', 'default', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          functional_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization:	'denied'
      });
    }

  }
}

function addSpaceBlock(element) {
   var elementHeight = element.clientHeight;
   if (elementHeight > 0) {
      element.parentElement.style.paddingBottom = elementHeight + 'px';
  }
  return false;
}

function removeSpaceBlock(element) {
  var elementHeight = element.clientHeight;
  if (elementHeight > 0) {
    element.parentElement.style.paddingBottom = 0 + 'px';
  }
  return false;
}

document.addEventListener("click", function(e){
  var editPrefs = e.target.closest('[data-preferences-edit]');
  if (editPrefs) {
    var elements = document.querySelectorAll('[data-cookie-preferences]');
    if (elements) {
      Array.from(elements).forEach( function(element) {
        removeSpaceBlock(element);
        element.hidden = true;
      })
    }
  }

  var cancelPrefs = e.target.closest('[data-cookie-preferences-cancel]');
  if (cancelPrefs) {
    e.hidden=true;
    var element = document.querySelectorAll('[data-cookie-preferences]');
    if (element) {
        element.hidden = false;
    }
  }
});

function savePrefs(e) {
  var savePrefs = e.target.closest('[data-cookie-preferences-save]');
  if (savePrefs) {
    var prefsform = document.getElementById('gdprPreferences');
    if (prefsform) {
      var checkboxes= prefsform.querySelectorAll('[type=checkbox]')
      var prefsObject = {};
      Array.from(checkboxes).forEach(function(checkbox) {
        prefsObject[checkbox.name] = (checkbox.checked)?1:0
      })
      var preferences = JSON.stringify(prefsObject);
      sendPrefs(preferences);
      modal.destroy();
      updateCookieConsent(preferences);
    }
  }
}

function cancelPrefs(e) {
  var cancelPrefs = e.target.closest('[data-cookie-preferences-cancel]');
  if (cancelPrefs) {
    var prefsform = document.getElementById('gdprPreferences');
    if (prefsform) {
        modal.destroy();
        var element =  document.querySelector('[data-cookie-preferences]');
    }
  }
}

function saveAllPrefs(e) {
  var iagreeBtn = e.target.closest('[data-cookie-preferences-all]');
  if (iagreeBtn) {
    var preferences = JSON.stringify({"required":1,"functional":1,"marketing":1,"analytics":1});
    sendPrefs(preferences);
    updateCookieConsent(preferences);
    var element = document.querySelector('[data-cookie-preferences]');
    if (element) {
      element.style.display = "none";
    }
  }
}

function sendPrefs(preferences) {
  var URL =  "/" + (config.translationPath).trim() + "/widget/cookiePreferencesModal";
  request.post(URL,preferences,"json")
}

function updateCookieConsent(preferences) {
  //convert preferences string back to object
  var prefs = JSON.parse(preferences)
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'update', {
    ad_storage: prefs.marketing==1?'granted':'denied',
    analytics_storage: prefs.analytics==1?'granted':'denied',
    functional_storage: prefs.functional == 1 ? 'granted' : 'denied',
    ad_user_data: prefs.marketing==1?'granted':'denied',
    ad_personalization:	prefs.marketing==1?'granted':'denied'
  });

  if (prefs.marketing==0) {
    gtag('set', 'ads_data_redaction', true)
  }

  if (prefs.analytics == 1) {
    var event = new Event("trigger-VWO-setup", {bubbles:true});
    document.dispatchEvent(event);
  }
}

document.addEventListener('DOMContentLoaded',init)
document.addEventListener('click',savePrefs)
document.addEventListener('click',saveAllPrefs)
document.addEventListener('click',cancelPrefs)